import { Flex, Heading, InlineList, Text } from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { sort } from "../../utils/utils";

const Courses = ({ courses }) => {
  const [fetchedCourses, setFetchedCourses] = useState([]);
  const [externalContexts, setExternalContexts] = useState([]);

  useEffect(() => {
    if (courses) {
      const fetched = [];
      const external = [];
      for (const course of courses) {
        if (course.creation_method === "manual") {
          external.push(course);
        } else {
          fetched.push(course);
        }
      }
      setExternalContexts(sort(external, (item) => item.code));
      setFetchedCourses(sort(fetched, (item) => item.code));
    }
  }, [courses]);

  const coursesPanel = (panelName, courses, noCoursesTitle) => {
    return (
      <>
        <Flex.Item width="100%">
          <Heading as="h4" level="h4">
            {panelName}
          </Heading>
        </Flex.Item>
        <Flex.Item>
          {courses.length > 0 ? (
            <InlineList delimiter="pipe">
              {courses.map((course, key) => (
                <InlineList.Item key={key}>
                  <Text>{course.code}</Text>
                </InlineList.Item>
              ))}
            </InlineList>
          ) : (
            <Text>{noCoursesTitle}</Text>
          )}
        </Flex.Item>
      </>
    );
  };

  return (
    <Flex vAlign="middle" gap="small" padding="x-small" wrap="wrap">
      {coursesPanel(
        t("navigation.courses"),
        fetchedCourses,
        t("academicHierarchy.noCourses")
      )}
      {coursesPanel(
        t("academicHierarchy.externalAssessmentContexts"),
        externalContexts,
        t("academicHierarchy.noContexts")
      )}
    </Flex>
  );
};

export default Courses;
